import "@fontsource/dm-sans"

export const onServiceWorkerUpdateReady = () => window.location.reload()
